// Figma: login-magic-link-sent (node 18050:550) / login-resend-confirmation (node
// 18050:604) — same template, two sub-states: "Resend link" ready, or mid-cooldown after
// a resend ("Resend link in 00:59"). Shown after updateLoginSession/updateSignUpSession
// succeeds — LC2's old flow just showed a generic Alert with the raw success payload;
// this reproduces the richer Figma confirmation screen using the same submitted email.
import React from 'react';
import PropTypes from 'prop-types';
import StatusCard from './components/StatusCard';
import mailIcon from '../../assets/auth/mail-icon.svg';
import {tokens} from '../../themes/ThemeCustomization';

const formatCooldown = (seconds) => `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;

const CheckInboxCard = ({email, onResend, onBackToLogin, resendLoading, cooldownSeconds}) => (
    <StatusCard
        icon={mailIcon}
        iconBackground={tokens.color.sky50}
        title="Check your inbox"
        description={
            <>
                We&apos;ve sent a link to <strong>{email}</strong>. Click the link in the email to login.
            </>
        }
        primaryAction={{
            label: cooldownSeconds > 0 ? `Resend link in ${formatCooldown(cooldownSeconds)}` : 'Resend link',
            onClick: onResend,
            loading: resendLoading,
            disabled: cooldownSeconds > 0
        }}
        secondaryAction={{label: 'Back to login', onClick: onBackToLogin}}
        caption="Link expires in 15 minutes."
    />
);

CheckInboxCard.propTypes = {
    email: PropTypes.string.isRequired,
    onResend: PropTypes.func.isRequired,
    onBackToLogin: PropTypes.func.isRequired,
    resendLoading: PropTypes.bool,
    cooldownSeconds: PropTypes.number
};

export default CheckInboxCard;
